import React from 'react';
import { motion } from 'framer-motion';
import { Check, Plus } from 'lucide-react';
import { Button } from '../ui/Button';
export function OfferStack() {
  return <section className="py-24 bg-dark-DEFAULT" id="offer" data-id="element-114">
      <div className="max-w-4xl mx-auto px-4" data-id="element-115">
        <div className="text-center mb-12" data-id="element-116">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-117">
            Here's Everything You Get
          </h2>
          <p className="text-xl text-gray-400" data-id="element-118">
            The complete arsenal to declare war on bad credit.
          </p>
        </div>

        <div className="bg-dark-100 border border-dark-200 rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-119">
          {/* Top Highlight Line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-120"></div>

          <div className="p-8 md:p-12" data-id="element-121">
            {/* Main Product */}
            <div className="flex flex-col md:flex-row gap-8 items-center border-b border-gray-800 pb-8 mb-8" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/ibfxiMXZPK16EfkAhYYNzD/producto1-1.png" alt="Product" className="w-48 drop-shadow-xl" data-id="element-123" />
              <div className="text-left flex-1" data-id="element-124">
                <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-125">
                  The Credit Repair Sledgehammer PDF
                </h3>
                <p className="text-gray-400 mb-4" data-id="element-126">
                  The exact step-by-step guide explaining the Section 609
                  loophole and how to execute it perfectly.
                </p>
                <div className="text-gold font-bold text-xl" data-id="element-127">$97 Value</div>
              </div>
            </div>

            {/* Bonuses */}
            <div className="space-y-6 mb-12" data-id="element-128">
              {[{
              title: "Bonus #1: The 'Freeze & Clear' Strategy",
              desc: 'Delete hard inquiries overnight by freezing secondary bureaus.',
              value: '$47'
            }, {
              title: 'Bonus #2: The Goodwill Letter Template',
              desc: 'Remove late payments from open accounts without closing them.',
              value: '$37'
            }, {
              title: "Bonus #3: The 'Stall Tactic' Rebuttal",
              desc: 'What to say when they try to delay you with form letters.',
              value: '$27'
            }].map((bonus, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-129">
                  <div className="bg-gold/10 p-2 rounded-full mt-1" data-id="element-130">
                    <Plus className="w-5 h-5 text-gold" data-id="element-131" />
                  </div>
                  <div className="flex-1" data-id="element-132">
                    <h4 className="text-lg font-bold text-white" data-id="element-133">
                      {bonus.title}
                    </h4>
                    <p className="text-sm text-gray-400" data-id="element-134">{bonus.desc}</p>
                  </div>
                  <div className="text-gray-500 font-bold hidden sm:block" data-id="element-135">
                    {bonus.value}
                  </div>
                </div>)}
            </div>

            {/* Total Value & Price */}
            <div className="bg-dark-50 rounded-xl p-8 text-center border border-dark-200" data-id="element-136">
              <div className="inline-block bg-danger/10 border border-danger/30 px-4 py-1 rounded-full mb-4" data-id="element-137">
                <span className="text-danger text-sm font-bold uppercase tracking-wider" data-id="element-138">
                  🔥 Launch Special — Save 76%
                </span>
              </div>
              <p className="text-gray-500 uppercase tracking-widest text-sm mb-2" data-id="element-139">
                Regular Price:{' '}
                <span className="line-through text-gray-400" data-id="element-140">$27</span>
              </p>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-141">
                <span className="text-6xl font-heading font-bold text-gold" data-id="element-142">
                  $6.39
                </span>
                <span className="text-xl text-gray-400 font-medium self-end mb-2" data-id="element-143">
                  / one-time
                </span>
              </div>
              <p className="text-gray-500 text-xs mb-6" data-id="element-144">
                No subscription. No monthly fees. Yours forever.
              </p>
              <Button variant="primary" size="xl" fullWidth className="mb-4 text-lg" onClick={() => document.getElementById('final-cta')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-145">
                Download The Sledgehammer Now
              </Button>
              <p className="text-xs text-gray-500" data-id="element-146">
                Secure 256-bit SSL Encryption. Instant Digital Delivery.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}